import SocialButtonDemo from './SocialButtonDemo'

export default SocialButtonDemo
// eslint-disable-next-line import/export
export * from './SocialButtonDemo'
